import { Box, SpaceBetween } from "@amzn/awsui-components-console";
import React from "react";

import SupportHelpBox from "./SupportHelpBox";

const ChatHelpPanel: React.FC = () => (
  <SpaceBetween size="m">
    <Box>
      <p>
        Welcome to Mamba! I’m a Large Language Model NBA expert and I can assist
        with statistical questions you have from 2016-2025 and will link you to
        relevant footage in Iconik. Ask a question to get started!
      </p>
      <h3>How to use the Chat</h3>
      <ul>
        <li>Ask an NBA question in the input field</li>
        <li>View model response in real-time</li>
        <li>Multi-turn questions in same context window</li>
      </ul>
      <h3>Conversation History</h3>
      Your conversation history is managed in the panel on the left side of the
      interface. You are able to manage your chat history in the following ways:
      <ul>
        <li>Pin Favorites</li>
        <li>Rename Chats</li>
        <li>Delete Chats</li>
      </ul>
    </Box>
    <SupportHelpBox />
  </SpaceBetween>
);

export default ChatHelpPanel;
